import { configureStore } from "@reduxjs/toolkit"
import DetailsActionSlice from "./GroupDashboardDetails/action-slice"
import DetailsIndividualPerformanceSlice from "./GroupDashboardDetails/individual-performance-slice"
import DetailsRecommendationSlice from "./GroupDashboardDetails/recommendation-slice"
import AuthSlice from "./auth-slice"
import DashboardSlice from "./dashboard-slice"
import GameFormSlice from "./form-game-slice"
import GameReportSlice from "./game-report-slice"
import GamelistSlice from "./gamelist-slice"
import ScenarioSlice from "./scenario-slice"
import UiSlice from "./ui-slice"

const store = configureStore({
  reducer: {
    auth: AuthSlice.reducer,
    ui: UiSlice.reducer,
    gameForm: GameFormSlice.reducer,
    gameReport: GameReportSlice.reducer,
    gamelist: GamelistSlice.reducer,
    dashboard: DashboardSlice.reducer,
    detailsRecommendations: DetailsRecommendationSlice.reducer,
    detailsActions: DetailsActionSlice.reducer,
    detailsIndividualPerformance: DetailsIndividualPerformanceSlice.reducer,
    scenarios: ScenarioSlice.reducer,
  },
})

export default store
